/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export var RequiredClaimsEnum;
(function (RequiredClaimsEnum) {
    RequiredClaimsEnum["USER_IDENTIFIER"] = "userIdentifier";
    RequiredClaimsEnum["PRINCIPAL_NAME"] = "principalName";
    RequiredClaimsEnum["DISPLAY_NAME"] = "displayName";
})(RequiredClaimsEnum || (RequiredClaimsEnum = {}));
export class RequiredClaims {
}
RequiredClaims.USER_IDENTIFIER = 'userIdentifier';
RequiredClaims.PRINCIPAL_NAME = 'principalName';
RequiredClaims.DISPLAY_NAME = 'displayName';
RequiredClaims.REQUIRED_CLAIMS = [
    RequiredClaimsEnum.USER_IDENTIFIER,
    RequiredClaimsEnum.PRINCIPAL_NAME,
    RequiredClaimsEnum.DISPLAY_NAME
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVxdWlyZWQtY2xhaW1zLmVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvc2hhcmVkL2F1dGhlbnRpY2F0aW9uL2NsYWltcy9yZXF1aXJlZC1jbGFpbXMuZW51bS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQUNILE1BQU0sQ0FBTixJQUFZLGtCQUlYO0FBSkQsV0FBWSxrQkFBa0I7SUFDMUIsd0RBQWtDLENBQUE7SUFDbEMsc0RBQWdDLENBQUE7SUFDaEMsa0RBQTRCLENBQUE7QUFDaEMsQ0FBQyxFQUpXLGtCQUFrQixLQUFsQixrQkFBa0IsUUFJN0I7QUFHRCxNQUFNLE9BQU8sY0FBYzs7QUFDQSw4QkFBZSxHQUFHLGdCQUFnQixDQUFDO0FBQ25DLDZCQUFjLEdBQUcsZUFBZSxDQUFDO0FBQ2pDLDJCQUFZLEdBQUcsYUFBYSxDQUFDO0FBRTdCLDhCQUFlLEdBQXlCO0lBQzNELGtCQUFrQixDQUFDLGVBQWU7SUFDbEMsa0JBQWtCLENBQUMsY0FBYztJQUNqQyxrQkFBa0IsQ0FBQyxZQUFZO0NBQ2xDLENBQUEifQ==